import type { QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"
import { ErrorDialogProvider } from "@/shared/components/ErrorDialog"

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return (
    <ErrorDialogProvider>
      <Outlet />
    </ErrorDialogProvider>
  )
}
